import { render, staticRenderFns } from "./Command.vue?vue&type=template&id=668557bf&scoped=true"
import script from "./Command.vue?vue&type=script&lang=js"
export * from "./Command.vue?vue&type=script&lang=js"
import style0 from "./Command.vue?vue&type=style&index=0&id=668557bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668557bf",
  null
  
)

export default component.exports